import { AmrTableMarkdownItem } from '#components/markdown/plugins/amr-table-markdown-item.js';
import { DriveModesTableMarkdownItem } from '#components/markdown/plugins/drive-modes-table-markdown-item.js';
import { FloatsAndTiesTableMarkdownItem } from '#components/markdown/plugins/floats-and-ties-table-markdown-item.js';
import { OcsTableMarkdownItem } from '#components/markdown/plugins/ocs-table-markdown-item.js';
import { ParametersAndModesTableMarkdownItem } from '#components/markdown/plugins/parameters-and-modes-table-markdown-item.js';
import { PinoutTableMarkdownItem } from '#components/markdown/plugins/pinout-table-markdown-item.js';
import { SigmaModelSignalPinsTableMarkdownItem } from '#components/markdown/plugins/sigma-model-signal-pins-table-markdown-item.js';
import { SignalsTableMarkdownItem } from '#components/markdown/plugins/signals-table-markdown-item.js';

import type { ComponentType } from 'react';

export interface HilDirectiveTable {
	Item: ComponentType<{ jsonData?: string }>;
	/** Tool-argument property holding the table's row array. */
	argKey: string;
}

/** Table renderer and row-argument key for each `hilDirective_*` table tool. */
export const HIL_DIRECTIVE_TABLES: Record<string, HilDirectiveTable> = {
	hilDirective_showSignalsTable: { Item: SignalsTableMarkdownItem, argKey: 'signals' },
	hilDirective_showPinoutTable: { Item: PinoutTableMarkdownItem, argKey: 'rows' },
	hilDirective_showDriveModesTable: { Item: DriveModesTableMarkdownItem, argKey: 'rows' },
	hilDirective_showAbsoluteMaximumRatingsTable: { Item: AmrTableMarkdownItem, argKey: 'rows' },
	hilDirective_showOperatingConditionsTable: { Item: OcsTableMarkdownItem, argKey: 'rows' },
	hilDirective_showFloatsAndTiesTable: { Item: FloatsAndTiesTableMarkdownItem, argKey: 'rows' },
	hilDirective_showParametersAndModesTable: { Item: ParametersAndModesTableMarkdownItem, argKey: 'rows' },
	hilDirective_showSigmaModelSignalPinsTable: { Item: SigmaModelSignalPinsTableMarkdownItem, argKey: 'rows' },
};

/**
 * Whether a tool call should render as a HIL directive table.
 *
 * @param toolName - The tool name from the tool-call message part.
 * @returns True when a table renderer is registered for the tool.
 */
export function isHilDirectiveTableToolCall(toolName: string): boolean {
	return toolName in HIL_DIRECTIVE_TABLES;
}
